import React, { useState, useEffect, useCallback, useContext } from "react";
import {
  Row,
  Col,
  Button,
  Card,
  Table,
  ButtonGroup,
  Alert,
  ProgressBar,
  Badge,
  Tabs,
  Tab,
  Modal,
  Spinner,
} from "react-bootstrap";

import ApplyLeave from "./ApplyLeave";
import _ from "lodash";
import axios from "axios";
import Utils from "./../../common/Utils";
import LeaveCalendar from "./LeaveCalendar";
import DateTimePicker from "react-datetime-picker";
import moment from "moment";
import ChoosePlans from "../../components/application/ChoosePlans";
import { UserContext } from "../../common";
import { Select } from "@mui/material";

const Leave = (props) => {
  const { userData } = useContext(UserContext);
  const [showCal, setShowCal] = useState(false);

  const [stats, setStats] = useState({
    loading: false,
    total: 0,
    paid: 0,
    unpaid: 0,
    available: 0,
    wday_hours: "",
    leaves: 0,
  });

  const [myHolidays, setMyHolidays] = useState({
    loading: false,
    total: 0,
    start: 0,
    records: [],
  });
  const [teamRequests, setTeamRequests] = useState({
    loading: false,
    total: 0,
    start: 0,
    records: [],
  });
  const [teamSummary, setTeamSummary] = useState({
    loading: false,
    total: 0,
    start: 0,
    records: [],
    tab: 0,
  });

  const [tab, setTab] = useState(0);

  const [filter, setFilter] = useState({
    pp: Utils.perpage,
    st: 0,
    from: moment().startOf("year").toDate(),
    to: moment().endOf("year").toDate(),
    member: 0,
  });

  const [showReasonModal, setShowReasonModal] = useState(false);
  const [reasonInput, setReasonInput] = useState("");
  const [pendingAction, setPendingAction] = useState({ rid: null, aid: 0 });
  const [showReasonText, setShowReasonText] = useState(false);

  const addFilters = (start = 0) => {
    let str = _.compact(
      _.map(_.omit(filter, ["from", "to"]), (fv, fk) =>
        fv !== "" ? `${fk}=${fv}` : undefined,
      ),
    );
    str.push("st=" + start);
    str.push("from=" + moment(filter.from).format("YYYY-MM-DD"));
    str.push("to=" + moment(filter.to).format("YYYY-MM-DD"));
    return "?" + str.join("&");
  };

  const recallLeave = (lid) => {
    if (window.confirm("Are you sure you want to recall the holiday?")) {
      setMyHolidays({ ...myHolidays, loading: true });
      axios
        .post(Utils.apiUrl("leaves/recall"), `lid=${lid}`, Utils.apiHeaders())
        .then((res) => {
          window.alert(res.data.message);
          reloadStats();
          fetchMyHolidays();
        })
        .catch((err) => {
          window.alert(err.message);
          setMyHolidays({ ...myHolidays, loading: false });
        });
    }
  };

  const fetchMyHolidays = (start = 0) => {
    setMyHolidays({ ...myHolidays, loading: true });
    axios
      .get(
        Utils.apiUrl("leaves/fetchmyholidays") + addFilters(start),
        Utils.apiHeaders(),
      )
      .then((res) => {
        if (res.data.success) {
          setMyHolidays({
            ...myHolidays,
            loading: false,
            start: start,
            total: _.get(res, "data.total", myHolidays.total),
            records: res.data.records,
          });
        }
      })
      .catch((err) => {
        setMyHolidays({ ...myHolidays, loading: false });
        console.log(err);
      });
  };

  const fetchTeamRequests = (start = 0) => {
    setTeamRequests({ ...teamRequests, loading: true });
    axios
      .get(
        Utils.apiUrl("leaves/fetchteamrequests") + addFilters(start),
        Utils.apiHeaders(),
      )
      .then((res) => {
        if (res.data.success) {
          setTeamRequests({
            ...teamRequests,
            loading: false,
            start: start,
            total: _.get(res, "data.total", teamRequests.total),
            records: res.data.records,
            team: res.data.team,
          });
        }
      })
      .catch((err) => {
        setTeamRequests({ ...teamRequests, loading: false });
        console.log(err);
      });
  };

  const fetchTeamSummary = (start = 0, tab = null) => {
    if (_.isNull(tab)) {
      tab = teamSummary.tab;
    }

    setTeamSummary({ ...teamSummary, loading: true, tab: tab });

    axios
      .get(
        Utils.apiUrl("leaves/fetchteamsummary") +
          addFilters(start) +
          `&days=${tab}`,
        Utils.apiHeaders(),
      )
      .then((res) => {
        if (res.data.success) {
          setTeamSummary({
            ...teamSummary,
            loading: false,
            start: start,
            total: _.get(res, "data.total", teamSummary.total),
            records: res.data.records,
            tab: tab,
          });
        }
      })
      .catch((err) => {
        setTeamSummary({ ...teamSummary, loading: false });
        console.log(err);
      });
  };

  useEffect(() => {
    tab === 0
      ? fetchMyHolidays(0)
      : tab === 1
        ? fetchTeamRequests(0)
        : fetchTeamSummary(0, 0);
  }, [tab]);

  const reloadStats = () => {
    setStats((prev) => ({ ...prev, loading: true }));
    axios
      .get(Utils.apiUrl("leaves/fetchleavessummary"), Utils.apiHeaders())
      .then((res) => {
        setStats((prev) => {
          if (!res.data || !res.data.success || !_.isObject(res.data.data)) {
            return {
              ...prev,
              loading: false,
              total: 0,
              paid: 0,
              unpaid: 0,
              available: 0,
            };
          }
          const tmp = { ...prev, ...res.data.data };
          let total = Number(tmp.total_hours) || 0;
          if (total <= 0) {
            total = getTotalLeaves(tmp);
          }
          const paid = Number(tmp.paid) || 0;
          const unpaid = Number(tmp.unpaid) || Number(tmp.pending) || 0;
          let available = Number(tmp.available_hours);
          if (isNaN(available) || available <= 0) {
            available = Math.max(0, total - paid);
          }
          return {
            ...tmp,
            loading: false,
            total,
            paid,
            unpaid,
            available,
          };
        });
      })
      .catch(() => {
        setStats((prev) => ({
          ...prev,
          loading: false,
          total: 0,
          paid: 0,
          unpaid: 0,
          available: 0,
        }));
      });
  };

  useEffect(reloadStats, []);

  const initiateLeaveApproval = (rid, aid) => {
    setPendingAction({ rid, aid });
    setReasonInput("");
    if (aid === 0) {
      setShowReasonModal(true);
    }
  };

  useEffect(() => {
    if (pendingAction.aid === 1 || pendingAction.aid === 2) {
      handleReasonSubmit();
    }
  }, [pendingAction]);

  const handleReasonSubmit = () => {
    const { rid, aid } = pendingAction;

    if (aid === 0 && !reasonInput.trim()) {
      window.alert("Please enter a reason.");
      return;
    }
    //if (window.confirm(`You are going to ${aid === 0 ? "Disapprove" : "Approve"} this request, Continue?`)) {
    setShowReasonModal(false);
    setTeamRequests({ ...teamRequests, loading: true });
    axios
      .post(
        Utils.apiUrl("leaves/updateleave"),
        `rid=${rid}&aid=${aid}&reason=${encodeURIComponent(reasonInput)}`,
        Utils.apiHeaders(),
      )
      .then((res) => {
        if (res.data.success) {
          fetchTeamRequests(0);
        } else {
          window.alert(res.data.message);
          setTeamRequests({ ...teamRequests, loading: false });
        }
      })
      .catch((err) => {
        setTeamRequests({ ...teamRequests, loading: false });
        console.log(err);
      });
    //}
  };

  const showPagination = ({ loading, start, total }, callback) => {
    if (loading || (start === 0 && start + filter.pp >= total)) {
      return <></>;
    } else {
      return (
        <div className="d-flex flex-row-reverse">
          {start + filter.pp >= total && (
            <div className="text-disabled ms-2">
              <img
                src={`${process.env.PUBLIC_URL}/images/arrow-right-d.png`}
                alt="Next"
              />{" "}
              Next
            </div>
          )}
          {start + filter.pp < total && (
            <div
              className="clickable ms-2 text-clickable"
              onClick={() => callback(start + filter.pp)}
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/arrow-right.png`}
                alt="Next"
              />{" "}
              Next
            </div>
          )}
          {start >= filter.pp && (
            <div
              className="clickable text-clickable"
              onClick={() => callback(start - filter.pp)}
            >
              Previous{" "}
              <img
                src={`${process.env.PUBLIC_URL}/images/arrow-left.png`}
                alt="Previous"
              />
            </div>
          )}
          {start === 0 && (
            <div className="text-disabled">
              Previous{" "}
              <img
                src={`${process.env.PUBLIC_URL}/images/arrow-left-d.png`}
                alt="Previous"
              />
            </div>
          )}
        </div>
      );
    }
  };

  const renderMyHolidays = () => (
    <Card border="light" className="shadow table-section p-sm-0 p-lg-3">
      <Card.Body>
        {myHolidays.loading && (
          <Alert variant="success" className="p-3">
            <p className="loading-msg">Fetching my holidays.. </p>
            <ProgressBar variant="success" animated now={100} />
          </Alert>
        )}
        {!myHolidays.loading && (
          <>
            {myHolidays.records.length === 0 && (
              <Alert variant="warning">No holiday available!</Alert>
            )}
            {myHolidays.records.length > 0 && (
              <Table striped hover responsive className="text-nowrap">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Reason</th>
                    <th>Hours</th>
                    <th>Type</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {myHolidays.records.map((rec, idx) => {
                    return (
                      <tr key={rec.id}>
                        <td>
                          <span className="tb-lable tb-lable-warning">
                            {Utils.addZero(myHolidays.start + idx + 1)}.
                          </span>
                        </td>
                        <td>{moment(rec.leave_from).format("DD MMM, YY")}</td>
                        <td>{moment(rec.leave_to).format("DD MMM, YY")}</td>
                        <td>{rec.reason}</td>
                        <td>{rec.hours}</td>
                        <td>{parseInt(rec.paid) ? "Paid" : "Unpaid"}</td>
                        <td>
                          {_.isNull(rec.approved_at) && (
                            <>
                              <Badge className="bg-warning text-dark me-2">
                                Pending
                              </Badge>
                              <span
                                className="btn btn-danger btn-sm"
                                onClick={() => recallLeave(rec.id)}
                              >
                                Recall
                              </span>
                            </>
                          )}
                          {!_.isNull(rec.approved_at) && (
                            <>
                              {rec.is_approved === "0" && (
                                <Badge className={rec.manager_reason?.includes('Recalled') || rec.reason?.includes('recalled') ? "bg-dark text-white" : "bg-secondary text-white"}>
                                  {rec.manager_reason?.includes('Recalled') || rec.reason?.includes('recalled') ? "Recalled" : "Disapproved"}
                                </Badge>
                              )}
                              {rec.is_approved === "1" && (
                                <>
                                  <Badge className="bg-success text-white me-2">
                                    Approved
                                  </Badge>
                                  {rec.manager_reason?.includes('[RECALL REQUESTED') ? (
                                    <Badge className="bg-danger text-white">
                                      <i className="bi bi-clock-history me-1" />Recall Pending
                                    </Badge>
                                  ) : (
                                    moment(rec.leave_from)
                                      .startOf("day")
                                      .isAfter(moment().startOf("day")) && (
                                      <span
                                        className="btn btn-danger btn-sm"
                                        onClick={() => recallLeave(rec.id)}
                                      >
                                        Recall
                                      </span>
                                    )
                                  )}
                                </>
                              )}
                              {!_.isEmpty(rec.manager_reason) && (
                                <img
                                  src={`${process.env.PUBLIC_URL}/images/circle.png`}
                                  className="ms-2 clickable"
                                  style={{ width: 20, height: 20 }}
                                  title="Click to view the reason"
                                  onClick={() => setShowReasonText(rec)}
                                />
                              )}
                            </>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            )}
            {showPagination(myHolidays, fetchMyHolidays)}
          </>
        )}
      </Card.Body>
    </Card>
  );

  const filterTeamRequests = (e) => {
    e.preventDefault();
    fetchTeamRequests(0);
  };
  const renderTeamRequests = () => (
    <Card border="light" className="shadow table-section p-sm-0 p-lg-3">
      <Card.Body>
        {teamRequests.loading && (
          <Alert variant="success" className="p-3">
            <p className="loading-msg">Fetching Team's holiday requests.. </p>
            <ProgressBar variant="success" animated now={100} />
          </Alert>
        )}
        {!teamRequests.loading && (
          <>
            <form onSubmit={filterTeamRequests} className="mb-3">
              <div className="d-flex flex-column flex-lg-row align-items-stretch align-items-lg-center justify-content-between gap-3 p-3 bg-light rounded border">
                <div className="d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center gap-2">
                  <label className="fw-bold mb-0 text-nowrap" htmlFor="member">
                    Team Member:
                  </label>
                  <select
                    name="member"
                    className="form-select"
                    style={{ minWidth: "180px" }}
                    value={filter.member}
                    onChange={(e) =>
                      setFilter({
                        ...filter,
                        member: parseInt(e.target.value),
                      })
                    }
                  >
                    <option value={0}>All Team Members</option>
                    {_.get(teamRequests, "team", []).length > 0 &&
                      teamRequests.team.map((tm) => (
                        <option
                          key={tm.id}
                          value={tm.id}
                        >
                          {tm.name}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center gap-2 flex-wrap">
                  <div className="d-flex align-items-center gap-1">
                    <span className="small text-muted text-nowrap">From:</span>
                    <DateTimePicker
                      dayPlaceholder="dd"
                      monthPlaceholder="mm"
                      yearPlaceholder="yyyy"
                      clearIcon={null}
                      format="y-MM-dd"
                      onChange={(v) => setFilter({ ...filter, from: v })}
                      value={filter.from}
                    />
                  </div>
                  <div className="d-flex align-items-center gap-1">
                    <span className="small text-muted text-nowrap">To:</span>
                    <DateTimePicker
                      dayPlaceholder="dd"
                      monthPlaceholder="mm"
                      yearPlaceholder="yyyy"
                      clearIcon={null}
                      format="y-MM-dd"
                      onChange={(v) => setFilter({ ...filter, to: v })}
                      value={!_.isNull(filter.to) ? filter.to : filter.from}
                    />
                  </div>
                  <Button type="submit" variant="primary" className="px-3">
                    Filter
                  </Button>
                </div>
              </div>
            </form>

            {teamRequests.records.length === 0 && (
              <Alert variant="warning">No Requests found!</Alert>
            )}

            {teamRequests.records.length > 0 && (
              <>
                <Table striped hover responsive className="text-nowrap">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Applicant</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Reason</th>
                      <th>Hours</th>
                      <th>Type</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {teamRequests.records.map((rec, idx) => (
                      <tr key={rec.id}>
                        <td>
                          <span className="tb-lable tb-lable-warning">
                            {Utils.addZero(teamRequests.start + idx + 1)}.
                          </span>
                        </td>
                        <td>{rec.name}</td>
                        <td>{moment(rec.leave_from).format("DD MMM, YY")}</td>
                        <td>{moment(rec.leave_to).format("DD MMM, YY")}</td>
                        <td>{rec.reason}</td>
                        <td>{rec.hours}</td>
                        <td>{parseInt(rec.paid) ? "Paid" : "Unpaid"}</td>
                        <td>
                          {rec.manager_reason?.includes('[RECALL REQUESTED') ? (
                            <>
                              <Badge className="bg-danger text-white me-2" style={{ fontSize: "11px" }}>
                                ⚠️ Recall Requested
                              </Badge>
                              <Button
                                variant="danger"
                                size="sm"
                                className="ms-1 fw-bold"
                                onClick={() => initiateLeaveApproval(rec.id, 2)}
                                title="Approve Employee's Recall Request and Cancel this Holiday"
                              >
                                Approve Recall
                              </Button>
                            </>
                          ) : parseInt(rec.is_approved) === 1 ? (
                            <>
                              <Badge className="bg-success text-white me-2">
                                Approved
                              </Badge>
                              <span
                                className="btn btn-outline-danger btn-sm ms-1"
                                onClick={() => initiateLeaveApproval(rec.id, 2)}
                              >
                                Recall
                              </span>
                            </>
                          ) : rec.manager_reason?.includes('Recalled') || rec.reason?.includes('recalled') ? (
                            <Badge className="bg-dark text-white me-2">
                              Recalled by Employee
                            </Badge>
                          ) : _.isNull(rec.is_approved) ? (
                            <>
                              <Badge className="bg-warning text-dark me-2">
                                Pending
                              </Badge>
                              <span
                                className="btn btn-outline-success btn-sm ms-1"
                                onClick={() => initiateLeaveApproval(rec.id, 1)}
                              >
                                Approve
                              </span>
                              <span
                                className="btn btn-outline-secondary btn-sm ms-2"
                                onClick={() => initiateLeaveApproval(rec.id, 0)}
                              >
                                Disapprove
                              </span>
                            </>
                          ) : (
                            <Badge className="bg-secondary text-white me-2">
                              Disapproved
                            </Badge>
                          )}
                          <span
                            className="btn btn-outline-secondary btn-sm ms-2"
                            onClick={() =>
                              setShowCal({
                                fromDt: rec.leave_from,
                                toDt: rec.leave_to,
                              })
                            }
                          >
                            Calendar
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </>
            )}
          </>
        )}
        {showPagination(teamRequests, fetchTeamRequests)}
      </Card.Body>
    </Card>
  );

  const renderTeamSummary = () => (
    <Card border="light" className="shadow table-section p-sm-0 p-lg-3">
      <Card.Body>
        <Row>
          <Col>
            <h3 className="my-2 title">Team’s Holiday Summary</h3>
          </Col>
          {/*<Col className="text-end">
            <Row>
                  <Col className="mb-3 d-flex justify-content-end text-right">
                    <div className="d-flex">
                      <DateTimePicker
                        disableClock={true}
                        clearIcon={null}
                        format="y-MM-dd"
                        onChange={(v) => {
                          if(filter.to < v){
                            alert("To date should be greater than or equal to From date");
                            return;
                          } else{
                            setFilter({...filter, from: v });
                          }
                        }}
                        value={filter.from}
                      />
                      <span className="m-2 mx-4">To</span>
                      <DateTimePicker
                        disableClock={true}
                        clearIcon={null}
                        format="y-MM-dd"
                        onChange={(v) => {
                          if(filter.from > v){
                            alert("From date should be less than or equal to To date");
                            return;
                          }else{
                            setFilter({ ...filter, to: v });
                          }
                        }}
                        value={filter.to}
                      />
                    </div>
                  </Col>
            </Row>
          </Col>*/}
        </Row>

        {teamSummary.loading && (
          <Alert variant="success" className="p-3">
            <p className="loading-msg">Fetching Team's summary.. </p>
            <ProgressBar variant="success" animated now={100} />
          </Alert>
        )}
        {!teamSummary.loading && (
          <>
            {teamSummary.records.length === 0 && (
              <Alert variant="warning">No Team Summary found!</Alert>
            )}

            {teamSummary.records.length > 0 && (
              <Table striped hover responsive className="mt-1 text-nowrap">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Name</th>
                    <th className="text-center">Total</th>
                    <th className="text-center">Approved</th>
                    <th className="text-center">Pending</th>
                    <th className="text-center">Available</th>
                    <th className="text-center">Unpaid</th>
                  </tr>
                </thead>
                <tbody>
                  {teamSummary.records.length > 0 &&
                    teamSummary.records.map(renderTeamSummaryItem)}
                </tbody>
              </Table>
            )}
            {showPagination(teamSummary, fetchTeamSummary)}
          </>
        )}
      </Card.Body>
    </Card>
  );

  const getTotalLeaves = (u) => {
    if (!u) return 0;
    const leavesVal = parseFloat(u.leaves) || 0;
    if (leavesVal <= 0) return 0;

    if (u.wday_hours != null && String(u.wday_hours).trim() !== "") {
      const wdh = _.compact(_.map(_.split(String(u.wday_hours), ","), (v) => parseFloat(v) || 0));
      const weeklyHours = _.sum(wdh);
      if (weeklyHours > 0) {
        if (leavesVal <= 100) {
          return Math.round((weeklyHours * 52 * leavesVal) / 100);
        } else {
          return Math.round(leavesVal);
        }
      }
    }

    return Math.round(leavesVal);
  };

  const renderTeamSummaryItem = (ts, idx) => {
    const pending = ts.pending == null ? 0 : parseFloat(ts.pending);
    const approved = ts.approved == null ? 0 : parseFloat(ts.approved);
    const total = getTotalLeaves({
      wday_hours: ts.wday_hours,
      leaves: ts.leaves,
    });
    const unpaid = ts.unpaid == null ? 0 : parseFloat(ts.unpaid);
    const available = Math.max(0, total - approved);

    return (
      <tr>
        <td>{Utils.addZero(teamSummary.start + idx + 1)}</td>
        <td>{ts.name}</td>
        <td className="text-center">{_.round(total, 0)}</td>
        <td className="text-center">{_.round(approved, 0)}</td>
        <td className="text-center">{_.round(pending, 0)}</td>
        <td className="text-center">{_.round(available, 0)}</td>
        <td className="text-center">{_.round(unpaid, 0)}</td>
      </tr>
    );
  };

  const renderReasonModal = () => {
    return (
      <Modal
        show={showReasonModal}
        onHide={() => setShowReasonModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {pendingAction.aid === 1 ? "Approve" : "Disapprove"} Leave Request
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label>
            Please enter a reason {pendingAction.aid === 0 && <>*</>}:
          </label>
          <textarea
            className="form-control"
            value={reasonInput}
            onChange={(e) => setReasonInput(e.target.value)}
            rows={3}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowReasonModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleReasonSubmit}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const renderReasonText = () => {
    return (
      <Modal
        show={showReasonText}
        onHide={() => setShowReasonText(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Manager's {showReasonText.approved ? "Approval" : "Disapproval"}{" "}
            Reason
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="warning" className="p-3">
            {showReasonText.manager_reason}
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowReasonText(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const statNum = (v) => _.round(Number(v) || 0, 0);

  if (!Utils.hasAccess(5)) {
    return (
      <>
        {!userData.is_super_user && (
          <h1 className="alert alert-danger p-5 mt-5">No access!</h1>
        )}
        {userData.is_super_user && (
          <>
            <h1 className="alert alert-danger p-4 mt-4">
              You current plan is restricted to use this module, please Upgrade!
            </h1>
            <ChoosePlans
              onPayment={() => {
                window.location.reload();
              }}
            />
          </>
        )}
      </>
    );
  }

  return (
    <div className="mt-3">
      {/* Real DenTTrack Leave Quotas */}
      <section className="dt-card">
        <div className="dt-card__head">
          <h2 className="dt-card__title">My Holiday Allowance (Real KPIs)</h2>
          {stats.loading && <Spinner animation="border" size="sm" variant="primary" />}
        </div>
        {!stats.loading && (
          <>
            <div className="streaks-grid">
              <div className="dt-streak">
                <div className="dt-streak__ico" style={{ background: "var(--brand-wash)", color: "var(--dt-navy)" }}>
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
                </div>
                <div className="dt-streak__n">{statNum(stats.total)}</div>
                <div className="dt-streak__l">Total Entitled Hours</div>
              </div>

              <div className="dt-streak">
                <div className="dt-streak__ico" style={{ background: "var(--mint-wash)", color: "var(--mint)" }}>
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="m5 12.5 4.5 4.5L19 7"/></svg>
                </div>
                <div className="dt-streak__n" style={{ color: "var(--mint)" }}>{statNum(stats.paid)}</div>
                <div className="dt-streak__l">Taken / Paid Hours</div>
              </div>

              <div className="dt-streak">
                <div className="dt-streak__ico" style={{ background: "var(--coral-wash)", color: "var(--coral)" }}>
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg>
                </div>
                <div className="dt-streak__n" style={{ color: "var(--coral)" }}>{statNum(stats.unpaid)}</div>
                <div className="dt-streak__l">Pending Approval Hours</div>
              </div>

              <div className="dt-streak">
                <div className="dt-streak__ico" style={{ background: "var(--amber-wash)", color: "var(--dt-amber)" }}>
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/></svg>
                </div>
                <div className="dt-streak__n" style={{ color: "var(--dt-amber)" }}>{statNum(stats.available)}</div>
                <div className="dt-streak__l">Available Balance Hours</div>
              </div>
            </div>

            {/* Quota Progress Bar */}
            <div className="mt-3 p-3 bg-light rounded border">
              <div className="d-flex justify-content-between small fw-bold mb-2">
                <span>Annual Leave Quota Utilization</span>
                <span style={{ color: "var(--dt-action)" }}>
                  {stats.total > 0 ? `${_.round((stats.available / stats.total) * 100, 0)}% Available` : "0% Available"}
                </span>
              </div>
              <div style={{ height: "8px", background: "var(--line)", borderRadius: "99px", overflow: "hidden", display: "flex" }}>
                <div style={{ height: "100%", width: `${stats.total > 0 ? (stats.paid / stats.total) * 100 : 0}%`, background: "var(--mint)" }} title="Taken Hours"></div>
                <div style={{ height: "100%", width: `${stats.total > 0 ? (stats.unpaid / stats.total) * 100 : 0}%`, background: "var(--coral)" }} title="Pending Hours"></div>
              </div>
            </div>
          </>
        )}
      </section>

      <Row className="mt-4">
        <Col>
          <ApplyLeave
            onApply={() => {
              fetchMyHolidays(0);
            }}
          />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <Tabs
            id="controlled-tab-example"
            activeKey={tab}
            onSelect={(k) => setTab(parseInt(k))}
            className="mb-3"
          >
            <Tab eventKey="0" title="My Holidays">
              {renderMyHolidays()}
            </Tab>
            <Tab eventKey="1" title="Holiday Requests">
              {renderTeamRequests()}
            </Tab>
            <Tab eventKey="2" title="Team Summary">
              {renderTeamSummary()}
            </Tab>
          </Tabs>
        </Col>
      </Row>

      {showCal !== false && (
        <LeaveCalendar
          fromDt={showCal.fromDt}
          toDt={showCal.toDt}
          onHide={() => setShowCal(false)}
        />
      )}

      {showReasonModal && renderReasonModal()}
      {showReasonText && renderReasonText()}
    </div>
  );
};

export default Leave;
